<template>
  <div class="footer">
    <!-- <div class="menuList">
      <BaseLink
        v-for="(menu, idx) in menuList"
        :key="idx"
        class="menu"
        :link-path="menu.url"
        :other-tab="true"
      >
        {{ menu.name }}
      </BaseLink>
    </div> -->
    <a
      class="company"
      href="https://www.zappallas.com/"
      target="_blank"
    >
      運営会社<img src="/static/img/choundiary/anotherLink.svg" />
    </a>
    <div class="inc">©ZAPPALLAS, INC. 2020</div>
  </div>
</template>

<script>
export default {
  name: 'FooterChoun',
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
.footer {
  background: #fff;
  border-top: 1px solid #E3D6CA;
  max-width: 580px;
  margin: 48px auto 0;

  .menuList {
    padding: 20px 48px 12px;
    display: flex;
    flex-wrap: wrap;

    .menu {
      width: 50%;
      font-size: 12px;
      margin: 8px 0;
      // @include mq('pc') {
      //   font-size: 12px;
      // }
    }
  }
  .company {
    background: #FFE546;
    font-size: 12px;
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    img {
      margin-left: 8px;
    }
  }
  .inc {
    font-size: 14px;
    padding: 18px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/FooterChoun.vue